import { Route, Switch } from 'react-router';

import urls from '~/views/urls';

import { CheckoutWizard } from '../CheckoutWizard/CheckoutWizard';
import { SubscriptionList } from '../SubscriptionList/SubscriptionList';

export const Subscription = () => (
  <div data-testid="Subscription">
    <Switch>
      <Route path={urls.checkout} component={CheckoutWizard} exact />
      <Route path={urls.subscription} component={SubscriptionList} exact />
    </Switch>
  </div>
);
